module.exports = __webpack_public_path__ + "img/5.5640785b.png";